export const DEFAULT_MAX_CHAR_COUNT = 8000
